import { Id } from 'NSwag/ServerClient/Client.nswag';
import { ILinkGeometries, ILinkMaps } from 'Store/index';
import Util from 'Util/index';

export const mapAdjacentLinks = (linkGeometries: ILinkGeometries): ILinkMaps => {

    let map: ILinkMaps = {};

    Object.keys(linkGeometries).forEach(currentLinkKey => {
        let currentLinkGeometry = linkGeometries[currentLinkKey];
        let geometryIdString = Util.IdToString(currentLinkGeometry.id!);
        let linkId: Id = new Id({ ...currentLinkGeometry.id! });
        linkId.resourceType = "link";
        let linkIdString = Util.IdToString(linkId);
        map[geometryIdString] = {
            linkId: linkIdString,
            prevLink: null,
            nextLink: null
        }

        if (currentLinkGeometry.startNode == null) {
            return;
        }

        Object.keys(linkGeometries).forEach(linkKey => {

            if (linkKey === Util.IdToString(currentLinkGeometry.id!)) {
                return;
            }

            let otherLinkGeometry = linkGeometries[linkKey];

            if (otherLinkGeometry.startNode == null || otherLinkGeometry.endNode == null) {
                return;
            }

            // ToDo: Should not be usng name here, could cause errors if multiple district data is present
            if (currentLinkGeometry.startNode!.id.name === otherLinkGeometry.endNode!.id.name) {
                map[geometryIdString].prevLink = Util.IdToString(otherLinkGeometry.id!);
            }

            if (currentLinkGeometry.endNode!.id.name === otherLinkGeometry.startNode!.id.name) {
                map[geometryIdString].nextLink = Util.IdToString(otherLinkGeometry.id!);
            }
        });
    });

    return map;
}